<template>
  <br>
  <table>
    <thead>
    <tr style="font-size: 16px">
      <th scope="col">
        <i class="fa fa-toggle-on" aria-hidden="true"></i>
        <i class="fa fa-toggle-off" aria-hidden="true"></i>
      </th>
      <th scope="col">30-daysFree</th>
      <th scope="col"> {{price_unit}} <i class="fa fa-usd" aria-hidden="true"></i></th>
      <th scope="col"><i class="fa fa-comments" aria-hidden="true"></i></th>
    </tr>
    </thead>
    <tbody>
    <tr>
      <th scope="row">Best for</th>
      <td>Web apps with payment</td>
      <td>Web apps with payment</td>
      <td>selling Digital or Physical products</td>
    </tr>
    <tr>
      <th scope="row">Validity period</th>
      <td>30 days</td>
      <td>forever</td>
      <td>Support 24/7, feedback welcome</td>
    </tr>
    <tr>
      <th scope="row">Payment Page models</th>
      <td>only B2B</td>
      <td>B2B or B2C</td>
      <td>without recurring payment </td>
    </tr>
    <tr>
      <th scope="row">Pay Page data confidentiality</th>
      <td style="color: limegreen"><i class="fa fa-shield" aria-hidden="true"></i></td>
      <td style="color: limegreen"><i class="fa fa-shield" aria-hidden="true"></i></td>
      <td>no data collected on our platform  </td>
    </tr>
    <tr>
      <th scope="row">Authentication Mode enabled</th>
      <td>yes</td>
      <td>yes</td>
      <td>UPAYS auth process could be used in your app for your customers</td>
    </tr>
    <tr>
      <th scope="row">Create customers [ on STRIPE account ]</th>
      <td>no</td>
      <td>yes</td>
      <td>speed up invoice creation [ STRIPE account ]</td>
    </tr>
    <tr>
      <th scope="row">Invoice generation</th>
      <td>no</td>
      <td>no</td>
      <td>it might be available in [ STRIPE account ]</td>
    </tr>
    <tr>
      <th scope="row">Email notification</th>
      <td>no</td>
      <td>no</td>
      <td>it might be available in [ STRIPE account ]</td>
    </tr>
    </tbody>
  </table>
  <br>
  <button class="close" @click="this.$router.go(-1)">Back</button>
  <br><br>
</template>
<script>
import {getPricingText} from "@/translate";

export default {
  name: 'Dashboard',
  data() {
    return {
      ptext:'',
      price_unit:29
    }
  },
  mounted() {
    this.ptext = getPricingText(0)
  },
  methods: {
  }
}
</script>
<style>
@import "../assets/buttons.css";
table {
  margin: 50px auto;
  border-collapse: collapse;
  border: 2px solid rgb(140 140 140);
  font-family: sans-serif;
  font-size: 0.8rem;
  letter-spacing: 1px;
}
caption {
  caption-side: bottom;
  padding: 10px;
  font-weight: bold;
}

thead,
tfoot {
  background-color: rgb(228 240 245);
}

th,
td {
  border: 1px solid rgb(160 160 160);
  padding: 8px 10px;
}

td:last-of-type {
  text-align: center;
}

tbody > tr:nth-of-type(even) {
  background-color: rgb(237 238 242);
}

tfoot th {
  text-align: right;
}

tfoot td {
  font-weight: bold;
}
@media screen and (max-width: 430px) {
  table {
    font-size: 0.5rem;
  }
}

</style>